import { useCartAndWishList } from '@contexts/CartAndWishList'
import getReferralCode from '@services/api/referrals/getReferralCode'
import countries from '@constants/countries'
import { ReferralUser } from '@type/referrals'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import UAParser from 'ua-parser-js'

type ReturnProps = {
  ipInfo: IpInfo | null
  userAgent: any
  isValidReferralCode: boolean
  referralUser: ReferralUser | null | undefined
  isError: boolean
  isLoading: boolean
}

const useReferralTracking = (): ReturnProps => {
  const { storeReferralCodeInLocalStorage, getReferralCodeFromLocalStorage } =
    useCartAndWishList()
  const [ipInfo, setIpInfo] = useState<IpInfo | null>(null)
  const [isValidReferralCode, setIsValidReferralCode] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [referralUser, setReferralUser] = useState<
    ReferralUser | undefined | null
  >(undefined)
  const parser = new UAParser()
  const userAgent = parser.getResult()
  const router = useRouter()

  const getIpInfo = async () => {
    const referrerCode = (router.query?.code || router.query?.ref) as string
    if (!referrerCode) {
      return setIsLoading(false)
    }
    const referrer = document.referrer || 'Direct'

    try {
      let info = ipInfo
      if (!ipInfo) {
        const res = await fetch('https://ipinfo.io/json')
        const data = await res.json()
        const countryCode = data.country as keyof typeof countries
        const newData: IpInfo = {
          ip: data.ip,
          city: data.city,
          region: data.region,
          country: countryCode,
          countryName: countries[countryCode] || countryCode,
          timezone: data.timezone,
          referrer,
        }
        setIpInfo(newData)
        info = newData
      }

      if (referrerCode) {
        const res = await getReferralCode({
          code: referrerCode,
          country: info?.countryName || '',
          platform: referrer,
          os: userAgent?.os?.name || '',
          isClick: 'true',
        })
        if (res) {
          setIsValidReferralCode(true)
          setReferralUser(res)
          const existingCode = getReferralCodeFromLocalStorage()
          console.log(existingCode, referrerCode)
          if (existingCode) {
            if (existingCode !== referrerCode)
              storeReferralCodeInLocalStorage(referrerCode)
          } else {
            storeReferralCodeInLocalStorage(referrerCode)
          }
        } else {
          setIsError(true)
          setReferralUser(null)
        }
      }
    } catch (error) {
      setIsError(true)
      setReferralUser(null)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getIpInfo()
  }, [])

  return {
    ipInfo,
    userAgent,
    isValidReferralCode,
    isError,
    referralUser,
    isLoading,
  }
}

export default useReferralTracking

interface IpInfo {
  ip: string
  city: string
  region: string
  country: string
  countryName: string
  timezone: string
  referrer: string
}
